(function ($, generic, site) {
  site.emailSignupPromotion = {
    templateContainer: $(),

    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form')
          ? $emailContainerNode
          : $('form', $emailContainerNode);
        var $emailError = $('.email-promotion__error', $emailContainerNode);
        var $emailCopy = $('.email-promotion__copy', $emailContainerNode);
        var $headerClock = $('.js-header-clock', $emailContainerNode);
        var $privacyPolicy = $('.js-new-privacy-policy', $emailContainerNode);
        var $newEmailCopy = $('.email-promotion__copy', '.js-email-promotion-new-design');
        var $emailPP = $('.email-promotion__pp', $emailContainerNode);
        var $emailSuccess = $('.email-promotion__success', $emailContainerNode);
        var $emailInput = $(
          '.email-promotion__form input[name="PC_EMAIL_ADDRESS"]',
          $emailContainerNode
        );
        var emailPromotions = $('input[name="PC_EMAIL_PROMOTIONS"]', $emailContainerNode);
        var $emailOptOutFlag = $('input[name="PC_EMAIL_OPTOUT_FLAG"]', $emailContainerNode);
        var $howUseData = $('.email-promotion__tooltip', $emailContainerNode);
        var isMobile = parseInt(Unison.fetch.now().width) === parseInt(Unison.fetch.all().small);
        var $termsConditions = $('input[name="ACCEPTED_PRIVACY_POLICY"]', $emailContainerNode);
        var $termsConditionsError = $('.js-untick-terms-conditions-error', $emailError);
        var $emailHeaderCopy = $emailContainerNode.find('.js-header');
        var $emailHeaderMobCopy = $emailContainerNode.find('.js-header-mob');
        var $emailSubheaderCopy = $emailContainerNode.find('.js-subheader');
        var $emailSubheaderMobCopy = $emailContainerNode.find('.js-subheader-mob');
        var $emailBodyCopy = $emailContainerNode.find('.js-body-copy');
        var $emailBodyMobCopy = $emailContainerNode.find('.js-body-copy-mob');
        var $thankyouCTA = $emailContainerNode.find('.js-thankyou-cta');
        var $thankyouCTAMob = $emailContainerNode.find('.js-thankyou-cta-mob');
        var thankyouCTAColorDT = $thankyouCTA.data('thankyou-cta-dt'); 
        var thankyouCTAColorMob = $thankyouCTAMob.data('thankyou-cta-mob');
        var $thankyouMob = $emailContainerNode.find('.js-thankyou-mob');
        var $thankyouDt = $emailContainerNode.find('.js-thankyou-dt');
        var $thankyouHeadingMob = $emailContainerNode.find('.js-thankyou-copy-main');
        var $termsConditionsCopy = $emailContainerNode.find('.js-email-promotion-terms-conditions');
        var termsColorMob = $termsConditionsCopy.data('terms-text-color');
        var $termsCopy = $emailContainerNode.find('.js-email-promotion-terms');
        var $tooltipCopy = $emailContainerNode.find('.js-email-promotion-tooltip');
        var tooltipColorMob = $tooltipCopy.data('how-we-use-text-color');
        var $timer = $emailContainerNode.find('.js-email-promotion-countdown-clock-timer');
        var $timerDynamic = $('.js-email-promotion-countdown-clock-timer-dynamic', '.js-email-promotion-new-design');
        var $days = $timer.find('.js-email-promotion-countdown-clock-timer--days');
        var $hours = $timer.find('.js-email-promotion-countdown-clock-timer--hours');
        var $minutes = $timer.find('.js-email-promotion-countdown-clock-timer--minutes');
        var $seconds = $timer.find('.js-email-promotion-countdown-clock-timer--seconds');
        var $countdownDate = $emailContainerNode.find('.js-email-promotion-countdown-clock__countdowndate');
        var countdownDate = $countdownDate.data('countdown-date');
        var imgHeight;
        var headerHeight = $emailContainerNode.parents('body').find('header.page-header').height();
        var footerHeight = $emailContainerNode.parents('body').find('footer .page-sticky-footer__inner').height();
        var contentHeight;
        var $content = $emailContainerNode.find('.js-email-promotion-content').not('.js-email-promotion-new-design');

        if (isMobile) {
          $emailContainerNode.find('.js-email-promotion-new-design').addClass('header-small-layout');
          $thankyouCTAMob.find('a').css('color', thankyouCTAColorMob);
          $termsConditionsCopy.css('color', termsColorMob);
          $termsCopy.find('.mantle-custom-text').css('color', tooltipColorMob);
          $tooltipCopy.find('.mantle-custom-text').css('color', tooltipColorMob);
          // wait for image to load before setting text to vertical align middle
          setTimeout(function () {
            imgHeight = $emailContainerNode.find('.email-promotion__mantle-image-container').height();
            if ($emailContainerNode.hasClass('email-promotion--body-under-hero')) {
              $emailCopy.css('height', imgHeight);
            }
          }, 2000);
          if ($emailHeaderMobCopy.length > 0) {
            $emailHeaderCopy.addClass('hidden');
            $emailHeaderMobCopy.removeClass('hidden');
          } 
          if ($emailSubheaderMobCopy.length > 0) {
            $emailSubheaderCopy.addClass('hidden');
            $emailSubheaderMobCopy.removeClass('hidden');
          }
          if ($emailBodyMobCopy.length > 0) {
            $emailBodyCopy.addClass('hidden');
            $emailBodyMobCopy.removeClass('hidden');
          }
          if ($thankyouMob.length > 0) {
            $thankyouDt.addClass('hidden');
            $thankyouMob.removeClass('hidden');
          }
        } else {
          // set content vertical middle of viewport
          contentHeight = $(window).height() - (headerHeight + footerHeight);
          $content.css('height', contentHeight);
          $thankyouCTA.find('a').css('color', thankyouCTAColorDT);
        }
        
        function setUnits(days, hours, minutes, seconds) {
          $days.html(days);
          $hours.html(hours);
          $minutes.html(minutes);
          $seconds.html(seconds);
        }

        function createTimer() {
          // Set the date we're counting down to
          var countDownDate = new Date(countdownDate).getTime();
          // Update the count down every 1 second
          var x = setInterval(function () {
            // Get today's date and time
            var now = new Date().getTime();
            // Find the distance between now and the count down date
            var distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            hours = addTimerZeros(hours);
            minutes = addTimerZeros(minutes);
            seconds = addTimerZeros(seconds);
            setUnits(days, hours, minutes, seconds);

            // If the count down is over, write some text
            if (distance < 0) {
              clearInterval(x);
              setUnits(0, 0, 0, 0);
            }
          }, 1000);
        }

        function addTimerZeros(time) {
          return (time < 10)? '0' + time : '' + time;
        }
        createTimer();

        if ($timerDynamic.length > 0) {
          var maxWidth = Math.max.apply(null, $timerDynamic.map(function() {
            return $(this).width();
          }).get());

          $timerDynamic.css('min-width', maxWidth);
        }

        $emailForm.once('email-signup__form').submit(function (submitEvt) {
          submitEvt.preventDefault();
          $emailInput.removeClass('error');
          $emailError.find('div').addClass('hidden');
          $termsConditionsError.addClass('hidden');

          var params = {};

          // Validate Checkbox state in front end before submitting form
          if (emailPromotions.length && !emailPromotions.is(':checked')) {
            $emailError.find('.untick_terms_message').removeClass('hidden');

            return false;
          }
          params.PC_EMAIL_PROMOTIONS = 1;

          if (
            $termsConditions.length > 0 &&
            $termsConditions.is(':checkbox') &&
            !$termsConditions.is(':checked')
          ) {
            $termsConditionsError.removeClass('hidden');

            return false;
          }
          params.ACCEPTED_PRIVACY_POLICY = 1;

          // Pass empty values; otherwise, default values may be saved to the database
          params.FIRST_NAME = '';
          params.LAST_NAME = '';

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });

          /* 
            This is for not to capture email option flag.
            Should not send a promotional email for certain scenarios
            Collecting 3rd party employee email addresses to give discounts
          */
          if ($emailOptOutFlag.length && parseInt($emailOptOutFlag.val(), 10)) {
            params.PC_EMAIL_PROMOTIONS = 0;
          }

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function () {
              $emailForm.addClass('hidden');
              $emailPP.addClass('hidden');
              $howUseData.addClass('hidden');
              $privacyPolicy.addClass('hidden');
              $emailError.find('div').addClass('hidden');
              $('body, html').animate({ scrollTop: 0 }, 400);
              $emailCopy.addClass('hidden');
              $emailContainerNode.find('.second-copy').addClass('hidden');
              $emailSuccess.removeClass('hidden');
              if (isMobile) {
                $newEmailCopy.removeClass('hidden');
                $headerClock.addClass('hidden');
                if ($emailContainerNode.hasClass('email-promotion--body-under-hero')) {
                  $thankyouHeadingMob.css('height', imgHeight);
                }
              }
            },
            onFailure: function () {
              if ($emailInput.val() !== '') {
                $emailError.find('.invalid_message').removeClass('hidden');
              } else if (!isMobile) {
                $emailInput.addClass('placeholderred');
              } else {
                $emailError.find('.blank_message').removeClass('hidden');
              }
            }
          });
        });
      });
    }
  };

  Drupal.behaviors.emailSignupPromotion = {
    attach: function (context) {
      site.emailSignupPromotion.templateContainer = $('.email-promotion', context);
      site.emailSignupPromotion.initEmailSignup();
    }
  };
})(jQuery, window.generic || {}, window.site || {});
